<template>
  <div>
    <div id="toast">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{ successTips }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      successTips:{
        type:String,
        default:'',
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/successToast.vue